module.exports = __webpack_public_path__ + "static/Elemental_Earth-bf64ed157631c656a467275c54fa4c38.jpg";